/// ITU-R M.1677-1 international Morse code table. Letters, digits, and
/// the common punctuation needed for nautical messages and standard
/// procedural signs.
///
/// Encoding is case-insensitive. Unknown characters surface as either
/// a skipped element (with `onUnknown: "skip"`) or a placeholder error
/// (with `onUnknown: "throw"`) so callers can decide between robust
/// rendering and strict validation.

export const ITU_CODE: Readonly<Record<string, string>> = Object.freeze({
  // Letters
  A: ".-",
  B: "-...",
  C: "-.-.",
  D: "-..",
  E: ".",
  F: "..-.",
  G: "--.",
  H: "....",
  I: "..",
  J: ".---",
  K: "-.-",
  L: ".-..",
  M: "--",
  N: "-.",
  O: "---",
  P: ".--.",
  Q: "--.-",
  R: ".-.",
  S: "...",
  T: "-",
  U: "..-",
  V: "...-",
  W: ".--",
  X: "-..-",
  Y: "-.--",
  Z: "--..",
  // Digits
  "0": "-----",
  "1": ".----",
  "2": "..---",
  "3": "...--",
  "4": "....-",
  "5": ".....",
  "6": "-....",
  "7": "--...",
  "8": "---..",
  "9": "----.",
  // Punctuation
  ".": ".-.-.-",
  ",": "--..--",
  "?": "..--..",
  "'": ".----.",
  "!": "-.-.--",
  "/": "-..-.",
  "(": "-.--.",
  ")": "-.--.-",
  "&": ".-...",
  ":": "---...",
  ";": "-.-.-.",
  "=": "-...-",
  "+": ".-.-.",
  "-": "-....-",
  _: "..--.-",
  '"': ".-..-.",
  $: "...-..-",
  "@": ".--.-.",
});

/// Reverse lookup — Morse pattern back to character. Built once at
/// module load.
export const ITU_DECODE: Readonly<Record<string, string>> = Object.freeze(
  Object.fromEntries(Object.entries(ITU_CODE).map(([k, v]) => [v, k])),
);
